<h2 mat-dialog-title class="gate-title">
  <mat-icon class="title-icon">campaign</mat-icon>
  {{ 'ANNOUNCEMENTS.GATE.TITLE' | translate }}
  @if (total > 1) {
    <span class="gate-progress">{{ 'ANNOUNCEMENTS.GATE.PROGRESS' | translate: { index, total } }}</span>
  }
</h2>

<mat-dialog-content class="dialog-container gate-content">
  @if (isLoading) {
    <div class="gate-loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading && loadError) {
    <div class="no-data gate-error">
      <mat-icon>wifi_off</mat-icon>
      <span>{{ 'ANNOUNCEMENTS.GATE.LOAD_ERROR' | translate }}</span>
    </div>
  }

  @if (!isLoading && !loadError && announcement) {
    <h3 class="gate-item-title">{{ announcement.title }}</h3>

    @if (announcement.editedAt) {
      <div class="gate-edited-marker">
        {{ 'ANNOUNCEMENTS.EDIT.EDITED_AT' | translate: { date: (announcement.editedAt | date: ('ANNOUNCEMENTS.FORMAT.DATE_TIME' | translate)) } }}
      </div>
    }

    @if (announcement.requiresAcknowledgment) {
      <span class="gate-ack-chip">
        <mat-icon>fact_check</mat-icon>
        {{ 'ANNOUNCEMENTS.ACK.REQUIRED' | translate }}
      </span>
    }

    <quill-view-html class="gate-body" [content]="cleanBody"></quill-view-html>

    @if (announcement.attachments?.length) {
      <ri-announcement-attachments [attachments]="announcement.attachments"></ri-announcement-attachments>
    }

    @if (confirmError && canCloseAfterConfirmError) {
      <div class="gate-inline-error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ 'ANNOUNCEMENTS.GATE.CONFIRM_ERROR' | translate }}</span>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isLoading && loadError) {
    @if (canCloseAfterLoadError) {
      <button type="button" mat-button class="btn-tertiary" (click)="onCloseTemporarily()">
        {{ 'ANNOUNCEMENTS.GATE.CLOSE_TEMPORARILY' | translate }}
      </button>
    }
    <button mat-raised-button class="btn-primary" (click)="onRetryLoad()">
      <mat-icon>refresh</mat-icon>
      {{ 'ANNOUNCEMENTS.GATE.RETRY' | translate }}
    </button>
  }

  @if (!isLoading && !loadError && announcement) {
    @if (confirmError && canCloseAfterConfirmError) {
      <button type="button" mat-button class="btn-tertiary"
        [disabled]="isSubmitting"
        (click)="onCloseTemporarily()">
        {{ 'ANNOUNCEMENTS.GATE.CLOSE_TEMPORARILY' | translate }}
      </button>
    }
    <button mat-raised-button class="btn-primary"
      [disabled]="isSubmitting"
      (click)="onConfirm()">
      @if (!isSubmitting) {
        <mat-icon>{{ announcement.requiresAcknowledgment ? 'fact_check' : 'done_all' }}</mat-icon>
      }
      @if (isSubmitting) {
        <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
      }
      {{ (announcement.requiresAcknowledgment ? 'ANNOUNCEMENTS.ACK.ACTION' : 'ANNOUNCEMENTS.GATE.MARK_READ') | translate }}
    </button>
  }
</mat-dialog-actions>
